import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledCategoryManagement = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .header-card {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .filters {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;
  }

  .search-input {
    min-width: 30%;
  }

  .language-filter {
    min-width: 30%;
  }

  .body-card {
    margin-bottom: 64px;
  }

  .header {
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .page-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 8px;
  }

  .search-create-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
  }

  .search-input {
    flex: 1;
    max-width: 400px;

    .MuiOutlinedInput-root {
      background-color: ${COLOR.white[100]};
      border-radius: 8px;

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${COLOR.primary.light};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${COLOR.primary.main};
      }
    }
  }

  .create-button {
    background: linear-gradient(
      135deg,
      ${COLOR.primary.main} 0%,
      ${COLOR.primary.dark} 100%
    );
    border-radius: 8px;
    padding: 10px 20px;
    font-weight: 600;
    text-transform: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      background: linear-gradient(
        135deg,
        ${COLOR.primary.dark} 0%,
        ${COLOR.primary.main} 100%
      );
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  .content-card {
    background: ${COLOR.white[100]};
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  .table-container {
    border-radius: 12px;
    overflow: hidden;
  }

  .data-table {
    .table-header {
      background: linear-gradient(
        135deg,
        ${COLOR.charcoal[8]} 0%,
        ${COLOR.charcoal[16]} 100%
      );

      .table-cell {
        color: ${COLOR.text.primary};
        font-weight: 600;
        font-size: 14px;
        padding: 16px 12px;
        border-bottom: 2px solid ${COLOR.charcoal[24]};
      }
    }

    .table-row {
      transition: all 0.2s ease;

      &:hover {
        background-color: ${COLOR.primary[4]};
      }

      .table-cell {
        padding: 12px;
        border-bottom: 1px solid ${COLOR.charcoal[16]};
        color: ${COLOR.text.primary};
        font-size: 14px;
      }
    }

    .loading-cell,
    .no-data-cell {
      text-align: center;
      padding: 40px;
      color: ${COLOR.text.secondary};
      font-style: italic;
    }
  }

  .action-buttons {
    display: flex;
    gap: 8px;
  }

  .edit-button {
    color: ${COLOR.primary.main};

    &:hover {
      background-color: ${COLOR.primary[8]};
    }
  }

  .delete-button {
    color: ${COLOR.error.main};

    &:hover {
      background-color: ${COLOR.error[8]};
    }
  }
`;

export const StyledCreateCategory = styled(Box)`
  .container {
    padding: 24px;
    background-color: ${COLOR.charcoal[4]};
    min-height: 100vh;
  }

  .header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
  }

  .back-button {
    color: ${COLOR.text.secondary};
    text-transform: none;
    font-weight: 500;

    &:hover {
      background-color: ${COLOR.charcoal[8]};
    }
  }

  .page-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
  }

  .form-container {
    background: ${COLOR.white[100]};
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  .language-section {
    margin-bottom: 32px;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[16]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );

    &:hover {
      border-color: ${COLOR.primary.light};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  }

  .language-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${COLOR.primary.light};
  }

  .field-label {
    color: ${COLOR.text.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 14px;

    .required {
      color: ${COLOR.error.main};
      margin-left: 4px;
    }
  }

  .form-section {
    margin-top: 24px;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[16]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );
  }

  .section-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${COLOR.primary.light};
  }

  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid ${COLOR.charcoal[16]};
  }

  .cancel-button {
    color: ${COLOR.text.secondary};
    border-color: ${COLOR.charcoal[32]};
    text-transform: none;
    font-weight: 500;

    &:hover {
      border-color: ${COLOR.charcoal[48]};
      background-color: ${COLOR.charcoal[8]};
    }
  }

  .submit-button {
    background: linear-gradient(
      135deg,
      ${COLOR.primary.main} 0%,
      ${COLOR.primary.dark} 100%
    );
    text-transform: none;
    font-weight: 600;
    padding: 10px 24px;

    &:hover {
      background: linear-gradient(
        135deg,
        ${COLOR.primary.dark} 0%,
        ${COLOR.primary.main} 100%
      );
    }

    &:disabled {
      background: ${COLOR.charcoal[32]};
      color: ${COLOR.text.disabled};
    }
  }
`;

export const StyledCategoryDetail = styled(Box)`
  .container {
    padding: 24px;
    background-color: ${COLOR.charcoal[4]};
    min-height: 100vh;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${COLOR.charcoal[16]};
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .back-button {
    color: ${COLOR.text.secondary};
    text-transform: none;
    font-weight: 500;

    &:hover {
      background-color: ${COLOR.charcoal[8]};
    }
  }

  .page-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
  }

  .status-switch {
    .MuiFormControlLabel-label {
      color: ${COLOR.text.primary};
      font-weight: 500;
    }
  }

  .form-container {
    background: ${COLOR.white[100]};
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }

  .language-section {
    margin-bottom: 32px;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[16]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );

    &:hover {
      border-color: ${COLOR.primary.light};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  }

  .language-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${COLOR.primary.light};
  }

  .field-label {
    color: ${COLOR.text.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 14px;

    .required {
      color: ${COLOR.error.main};
      margin-left: 4px;
    }
  }

  .form-section {
    margin-top: 24px;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[16]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );
  }

  .section-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${COLOR.primary.light};
  }

  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid ${COLOR.charcoal[16]};
  }

  .cancel-button {
    color: ${COLOR.text.secondary};
    border-color: ${COLOR.charcoal[32]};
    text-transform: none;
    font-weight: 500;

    &:hover {
      border-color: ${COLOR.charcoal[48]};
      background-color: ${COLOR.charcoal[8]};
    }
  }

  .submit-button {
    background: linear-gradient(
      135deg,
      ${COLOR.primary.main} 0%,
      ${COLOR.primary.dark} 100%
    );
    text-transform: none;
    font-weight: 600;
    padding: 10px 24px;

    &:hover {
      background: linear-gradient(
        135deg,
        ${COLOR.primary.dark} 0%,
        ${COLOR.primary.main} 100%
      );
    }

    &:disabled {
      background: ${COLOR.charcoal[32]};
      color: ${COLOR.text.disabled};
    }
  }
`;
